// @flow
export type AvailableOptionActionType =
  | {|
      type: 'SET_AVAILABLE_OPTIONS',
      payload: {|
        options: any,
      |},
    |}
  | {|
      type: 'FETCH_AVAILABLE_OPTIONS',
      payload: {|
        blackFriday?: boolean,
      |},
    |};

export const setAvailableOptions = (options: any): AvailableOptionActionType => ({
  type: 'SET_AVAILABLE_OPTIONS',
  payload: {
    options,
  },
});

export const fetchAvailableOptions = (blackFriday?: boolean): AvailableOptionActionType => ({
  type: 'FETCH_AVAILABLE_OPTIONS',
  payload: {
    blackFriday,
  },
});
